import React, { useState } from "react";

export default function EducationLoanForm() {
  const [agree, setAgree] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    reason: "",
    institution: "",
    studentName: "",
    studentClass: "",
    year: "",
    parentName: "",
    parentProfession: "",
    parentIncome: "",
    amount: "",
    emiCount: "",
    remarks: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!agree) {
      alert("You must agree to the Terms & Conditions before submitting.");
      return;
    }
    // console.log("Form Submitted:", formData);
    alert("Form submitted! Our Banking Partner Will Get Back To You.");
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-700 p-6">
      <form
        onSubmit={handleSubmit}
        className="bg-gray-600 shadow-lg rounded-2xl p-6 w-full max-w-lg"
      >
        <h2 className="text-xl font-bold text-center text-yellow-200 mb-4">
          EduEMI: Need Money for Education on Loan. Pay in EMI
        </h2>

        {/* Reason Dropdown */}
        <label className="block mb-2 font-medium">Reason</label>
        <select
          name="reason"
          value={formData.reason}
          onChange={handleChange}
          className="h-10 w-full p-2 mb-4 border rounded-lg"
        >
          <option value="">-- Select Reason --</option>
          <option value="Fee">Fee</option>
          <option value="Books">Books</option>
          <option value="Dress">Dress</option>
          <option value="Transport">Transport</option>
          <option value="Other">Other</option>
        </select>

        {/* Institution Name */}
        <label className="block mb-2 font-medium">Institution Name</label>
        <input
          type="text"
          name="institution"
          value={formData.institution}
          onChange={handleChange}
          style={{ width: "100%" }}
          className="w-full p-2 mb-4 border rounded-lg"
        />

        {/* Student Details */}
        <label className="block mb-2 font-medium">Student Name</label>
        <input
          type="text"
          name="studentName"
          value={formData.studentName}
          onChange={handleChange}
          style={{ width: "100%" }}
          className="w-full p-2 mb-4 border rounded-lg"
        />

        <label className="block mb-2 font-medium">Class</label>
        <input
          type="text"
          name="studentClass"
          value={formData.studentClass}
          onChange={handleChange}
          style={{ width: "200px" }}
          className="w-full p-2 mb-4 border rounded-lg"
        />

        <label className="block mb-2 font-medium">Year</label>
        <input
          type="text"
          name="year"
          value={formData.year}
          onChange={handleChange}
          style={{ width: "200px" }}
          className="w-full p-2 mb-4 border rounded-lg"
        />

        {/* Parent Details */}
        <label className="block mb-2 font-medium">Parent Name</label>
        <input
          type="text"
          name="parentName"
          value={formData.parentName}
          onChange={handleChange}
          style={{ width: "100%" }}
          className="w-full p-2 mb-4 border rounded-lg"
        />

        <label className="block mb-2 font-medium">Parent Profession</label>
        <input
          type="text"
          name="parentProfession"
          value={formData.parentProfession}
          onChange={handleChange}
          style={{ width: "100%" }}
          className="w-full p-2 mb-4 border rounded-lg"
        />

        <label className="block mb-2 font-medium">Parent Income</label>
        <select
          name="parentIncome"
          value={formData.parentIncome}
          onChange={handleChange}
          className="h-10 w-80 p-2 mb-4 border rounded-lg"
        >
          <option value="">-- Select Income Range --</option>
          <option value="<2L">Less than ₹2,00,000</option>
          <option value="2-5L">₹2,00,000 - ₹5,00,000</option>
          <option value="5-10L">₹5,00,000 - ₹10,00,000</option>
          <option value="10-20L">₹10,00,000 - ₹20,00,000</option>
          <option value=">20L">Above ₹20,00,000</option>
        </select>

        {/* Loan Details */}
        <label className="block mb-2 font-medium">Amount (INR)</label>
        <input
          type="number"
          name="amount"
          value={formData.amount}
          onChange={handleChange}
          style={{ width: "100px" }}
          className="w-full p-2 mb-4 border rounded-lg"
        />

        <label className="block mb-2 font-medium">Number of EMIs</label>
        <select
          name="emiCount"
          value={formData.emiCount}
          onChange={handleChange}
          className="h-10 w-40 p-2 mb-4 border rounded-lg"
        >
          <option value="">-- Select EMI Count --</option>
          <option value="3">3 months</option>
          <option value="6">6 months</option>
          <option value="9">9 months</option>
          <option value="12">12 months</option>
        </select>

        {/* Remarks */}
        <label className="block mb-2 font-medium">Remarks</label>
        <input
            type="text"
            name="remarks"
            value={formData.remarks}
            onChange={handleChange}
            style={{ width: "100%" }}
            className="w-full p-2 mb-4 border rounded-lg"
        />
        {/* Terms & Conditions Checkbox */}
        <div className="flex items-center mb-4">
          <input
            type="checkbox"
            checked={agree}
            onChange={(e) => setAgree(e.target.checked)}
            className="mr-2"
          />
          <button
              type="button"
              onClick={() => setShowModal(true)}
              className="text-white w-full"
            >
              I agree to the Terms & Conditions
          </button>
        </div>
        {/* Submit */}
        <button
          type="submit"
          className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg"
        >
          Submit
        </button>
      </form>
      {/* Terms & Conditions Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-gray-600 rounded-2xl shadow-lg w-11/12 max-w-2xl p-6 overflow-y-auto max-h-[80vh]">
            <h2 className="text-xl font-bold mb-4 text-center">
              EduEMI Terms & Conditions
            </h2>
            <div className="text-sm text-white space-y-3">
              <p>
                1. <strong>Loan Facilitation:</strong> EduEMI is a facilitation
                service. Loan disbursement, approval, and repayment are managed
                by our partnered NBFCs/MFIs. EduEMI itself does not provide or
                guarantee loans.
              </p>
              <p>
                2. <strong>Eligibility:</strong> Applicants must be parents or
                legal guardians of the student, provide accurate information,
                and complete mandatory KYC as per RBI/partner NBFC guidelines.
              </p>
              <p>
                3. <strong>Repayment:</strong> EMI repayment is the
                responsibility of the parent/guardian. Defaulting may lead to
                penalties, additional charges, and reporting to credit bureaus.
              </p>
              <p>
                4. <strong>Fee Payment:</strong> Loan amounts are disbursed
                directly to the educational institution. EduEMI/partners will
                not transfer loan funds directly to applicants.
              </p>
              <p>
                5. <strong>Renewals:</strong> Loan/EMI arrangements are valid
                for the approved academic year. Renewals are subject to fresh
                approval and credit checks.
              </p>
              <p>
                6. <strong>Accuracy of Data:</strong> Applicants must ensure all
                details entered are correct. EduEMI is not responsible for
                errors, misreporting, or incorrect institution details.
              </p>
              <p>
                7. <strong>Technical Glitches:</strong> EduEMI will take
                reasonable measures to maintain uninterrupted services but is
                not liable for delays due to network failures, technical issues,
                or force majeure events.
              </p>
              <p>
                8. <strong>Confidentiality:</strong> All personal and financial
                data will be handled securely and shared only with authorized
                lending partners, in line with data protection norms.
              </p>
              <p>
                9. <strong>Termination:</strong> EduEMI reserves the right to
                suspend or terminate services in cases of fraud, misuse, or
                breach of these Terms & Conditions.
              </p>
              <p>
                10. <strong>Jurisdiction:</strong> All disputes are subject to
                Indian laws and courts located in Mumbai jurisdiction.
              </p>
            </div>
            <div className="mt-6 flex justify-center">
              <button
                onClick={() => setShowModal(false)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
